import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environments';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private router: Router,
    private http: HttpClient
  ) { }

  login(email: any, password: any) {
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/login`, { email: email, password: password })
      .pipe(map(user => {
        localStorage.setItem(`${environment.appName}` + 'user', user.data.access_token);
        return user;
      }));
  }

  logout() {
    localStorage.removeItem(`${environment.appName}` + 'user');
    this.router.navigate(['/login']);
  }


  // schemelists
  getSchemeList(search: any, page: any) {
    return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/schemes/list?search=` + search + '&page=' + page);
  }

  getschemebyid(schemeId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/schemes/${schemeId}`)
  }


  // customer lists
  getCustomerList(search: any, page: any) {
    return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/users/list?search=` + search + '&page=' + page);
  }

  // user scheme deatils
  getUserSchemeList(search: any, page: any, startDate: any, endDate: any,branch:any) {
    return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/user-schemes/payment-list?search=` + search + '&page=' + page + '&startDate=' + startDate + '&endDate=' + endDate +'&branch=' + branch);
  }

  getuserschemebyid(userSchemeId: any, startDate: any, endDate: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/user-schemes/installment-list/${userSchemeId}?startDate=` + startDate + '&endDate=' + endDate)
  }

  syncUserSchemeData(mobileNumber: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/user-schemes/sync-user-scheme-data?mobileNumber=` + mobileNumber);
  }

  downloadUserSchemeExcel(userSchemeId: any, startDate: any, endDate: any,branch:any) {
    const file = this.http
      .get<Blob>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/user-schemes/userscheme-list-excel-download/${userSchemeId}?startDate=` + startDate + '&endDate=' + endDate + '&branch=' + branch,
        { responseType: "blob" as "json" }
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
    return file;
  }

  downloadPaymentExcel(search: any, startDate: any, endDate: any,branch:any) {
    const file = this.http.get<Blob>(`${environment.apiUrl}${environment.apiPrefix}/admin/user-schemes/installment-list/excel-download?search=` + search + '&startDate=' + startDate + '&endDate=' + endDate + '&branch=' + branch, { responseType: 'blob' as 'json' }).pipe(map(user => {
      return user
    }));
    return file;
  }

  // feedback lists
  getfeddbackList(search: any, page: any) {
    return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/fact-and-feeds/list?search=` + search + '&page=' + page);
  }

  getsfeddbackbyid(Id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/fact-and-feeds/${Id}`)
  }

  addFeddback(title: any, subtitle: any, description: any,
    imageFile: any,
  ) {
    var formData = new FormData();
    formData.append("title", title)
    formData.append("subtitle", subtitle)
    formData.append("description", description)
    if (imageFile) {
      formData.append("imageFile", imageFile);
    }
    return this.http.post<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/fact-and-feeds/add`,
      formData
    );
  }

  updateFeedback(
    Id: string,
    title: any,
    subtitle: any,
    description: any,
    imageFile: any,
  ) {
    var formData = new FormData()
    formData.append("title", title)
    formData.append("subtitle", subtitle)
    formData.append("description", description)
    if (imageFile) {
      formData.append("imageFile", imageFile);
    }
    return this.http.put<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/fact-and-feeds/update/${Id}`,
      formData
    );
  }

  deleteFeedback(Id: string): Observable<any> {
    return this.http.delete<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/fact-and-feeds/delete/${Id}`
    );
  }


// branches
getBranchList(search: any, page: any) {
  return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/list?search=` + search + '&page=' + page);
}

getBranchId(Id: any) {
  return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/list/${Id}`)
}

addBranch(name:any,branch: any, mobile: any, password: any
) {
  var formData = new FormData();
  formData.append("name", name)
  formData.append("branch", branch)
  formData.append("mobile", mobile)
  formData.append("password", password)

  return this.http.post<any>(
    `${environment.apiUrl}${environment.apiPrefix}/admin/add`,
    formData
  );
}

updateBranch(
  Id: string,
  name:any,
  branch: any, mobile: any, password: any
) {
  var formData = new FormData()
  formData.append("name", name)
  formData.append("branch", branch)
  formData.append("mobile", mobile)
  formData.append("password", password)

  return this.http.put<any>(
    `${environment.apiUrl}${environment.apiPrefix}/admin/update/${Id}`,
    formData
  );
}

deleteBranch(Id: string): Observable<any> {
  return this.http.delete<any>(
    `${environment.apiUrl}${environment.apiPrefix}/admin/delete/${Id}`
  );
}

getBranchDropdown() {
  return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/abharna-api/branch-list`).pipe(map(user => user))
}

resetAdminPassword(password: string) {
  const formData = {
    password: password,
  };
  return this.http.put<any>(
    `${environment.apiUrl}${environment.apiPrefix}/admin/update-password`,
    formData
  );
}

// Offers

getOffersList(search: any, page: any) {
  return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/offers/list?search=` + search + '&page=' + page);
}

getOffersbyid(Id: any) {
  return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/offers/${Id}`)
}

addOffers(title: any,
  imageFile: any,
) {
  var formData = new FormData();
  formData.append("title", title)
  if (imageFile) {
    formData.append("imageFile", imageFile);
  }
  return this.http.post<any>(
    `${environment.apiUrl}${environment.apiPrefix}/admin/offers/add`,
    formData
  );
}

updateOffers(
  Id: string,
  title: any,
  imageFile: any,
) {
  var formData = new FormData()
  formData.append("title", title)
  if (imageFile) {
    formData.append("imageFile", imageFile);
  }
  return this.http.put<any>(
    `${environment.apiUrl}${environment.apiPrefix}/admin/offers/update/${Id}`,
    formData
  );
}

deleteOffers(Id: string): Observable<any> {
  return this.http.delete<any>(
    `${environment.apiUrl}${environment.apiPrefix}/admin/offers/delete/${Id}`
  );
}

  // dashboard
  schemeDashboard() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/dashboard/counts`).pipe(map(user => user));
  }

  //media section post 
  getpostList(search: any, page: any) {
    return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/media-section/post/list?search=` + search + '&page=' + page);
  }

  getpostById(id: any,type:any) {
    return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/media-section/post/view/${id}?mediaType=`+type );
  }

  addPost(
    title: any,
    caption: any,
    type: any,
    imageFiles: File[],notify:any,notificationMessage:any,isScheduled:any,scheduleDate:any
  ) {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("caption", caption);
    formData.append("mediaType", type);
    formData.append("notify", notify);
    formData.append("notificationMessage", notificationMessage);
    formData.append("isScheduled", isScheduled);
    formData.append("scheduleDate", scheduleDate);
    if (imageFiles && imageFiles.length > 0) {
      imageFiles.forEach((file) => {
        formData.append("imageFiles", file); // same key for multiple files
      });
    }
  
    return this.http.post<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/media-section/post/upload`,
      formData
    );
  }

 
  updatePost(
    Id: string,
    title: any,
    caption: any,
    type: any,deletedImages:any,
    imageFiles: File[],notify:any,notificationMessage:any,isScheduled:any,scheduleDate:any
  ) {
    var formData = new FormData()
    formData.append("title", title)
    formData.append("caption", caption)
    formData.append("mediaType", type)
    formData.append("deletePaths", JSON.stringify(deletedImages))
    formData.append("status", '1'),
    formData.append("notify", notify);
    formData.append("notificationMessage", notificationMessage);
    formData.append("isScheduled", isScheduled);
    formData.append("scheduleDate", scheduleDate);
    if (imageFiles && imageFiles.length > 0) {
      imageFiles.forEach((file) => {
        formData.append("imageFiles", file); // same key for multiple files
      });
    }
  
    return this.http.put<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/media-section/post/${Id}`,
      formData
    );
  }

  notification(
  notificationMessage:any,id:any
  ) {
  let formData={
    notify:1,
    notificationMessage:notificationMessage
  }
  
    return this.http.put<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/media-section/notify/`+id,
      formData
    );
  }


  getsPosbyid(Id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/media-section/post/view/${Id}`)
  }

  deletePost(Id: string): Observable<any> {
    return this.http.delete<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/media-section/post/${Id}`
    );
  }

  //reels  

  getreelById(id: any) {
    return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/media-section/video/view/${id}` );
  }
   getreelsList(search: any, page: any,mediaType:string) {
    return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/media-section/video/list?search=` + search + '&page=' + page+'&mediaType=' +mediaType);
  }

  addReels(
    title: any,
    caption: any,
    type: any,
    videoFiles: File,thumbnailImage:File[],notify:any,notificationMessage:any,isScheduled:any,scheduleDate:any
  ) {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("caption", caption);
    formData.append("mediaType", type);
    formData.append("notify", notify);
    formData.append("notificationMessage", notificationMessage);
    formData.append("isScheduled", isScheduled);
    formData.append("scheduleDate", scheduleDate);
    // if (videoFiles && videoFiles.length > 0) {
    //   videoFiles.forEach((file) => {
        formData.append("videoFiles", videoFiles); // same key for multiple files
    //   });
    // }

    if (thumbnailImage && thumbnailImage.length > 0) {
      thumbnailImage.forEach((file) => {
        formData.append("thumbnailImage", file); // same key for multiple files
      });
    }
  
    return this.http.post<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/media-section/video/upload`,
      formData
    );
  }

  updateReels(
    Id: string,
    title: any,
    caption: any,
    type: any,videoFiles: File,thumbnailImage:File[],notify:any,notificationMessage:any,isScheduled:any,scheduleDate:any
  ) {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("caption", caption);
    formData.append("mediaType", type);
    formData.append("notify", notify);
    formData.append("notificationMessage", notificationMessage);
    formData.append("isScheduled", isScheduled);
    formData.append("scheduleDate", scheduleDate);
  
    // if (videoFiles && videoFiles.length > 0) {
    //   videoFiles.forEach((file) => {
        formData.append("videoFiles", videoFiles); // same key for multiple files
    //   });
    // }

    if (thumbnailImage && thumbnailImage.length > 0) {
      thumbnailImage.forEach((file) => {
        formData.append("thumbnailImage", file); // same key for multiple files
      });
    }
  
  
    return this.http.put<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/media-section/video/${Id}`,
      formData
    );
  }

  getsReelbyid(Id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/media-section/video/view/${Id}`)
  }

  deleteReel(Id: string): Observable<any> {
    return this.http.delete<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/media-section/video/${Id}`
    );
  }

  //Video

   getVideoList(search: any, page: any) {
    return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/media-section/video/list?search=` + search + '&page=' + page);
  }

  addVideo(
    title: any,
    caption: any,
    type: any,
    videoFiles: File,thumbnailImage:File[]
  ) {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("caption", caption);
    formData.append("mediaType", type);
  
    // if (videoFiles && videoFiles.length > 0) {
    //   videoFiles.forEach((file) => {
        formData.append("videoFiles", videoFiles); // same key for multiple files
    //   });
    // }

    if (thumbnailImage && thumbnailImage.length > 0) {
      thumbnailImage.forEach((file) => {
        formData.append("thumbnailImage", file); // same key for multiple files
      });
    }
  
    return this.http.post<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/media-section/video/upload`,
      formData
    );
  }

  updateVideo(
    Id: string,
    title: any,
    caption: any,
    type: any,videoFiles: File[],thumbnailImage:File[]
  ) {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("caption", caption);
    formData.append("mediaType", type);
  
    if (videoFiles && videoFiles.length > 0) {
      videoFiles.forEach((file) => {
        formData.append("videoFiles", file); // same key for multiple files
      });
    }

    if (thumbnailImage && thumbnailImage.length > 0) {
      thumbnailImage.forEach((file) => {
        formData.append("thumbnailImage", file); // same key for multiple files
      });
    }
  
  
    return this.http.put<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/media-section/video/${Id}`,
      formData
    );
  }

  getsVideobyid(Id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/media-section/video/view/${Id}`)
  }

  deleteVideo(Id: string): Observable<any> {
    return this.http.delete<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/media-section/video/${Id}`
    );
  }

  getscheduledList(search: any, page: any,mediaType:string,startDate:string,endDate:string) {
    return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/media-section/schedule/list?search=` + search + '&page=' + page+'&mediaType=' +mediaType
      +'&startDate='+startDate+'&endDate='+endDate
    );
  }


}
